import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Sparkles } from "lucide-react";
import { isUsClinicalHost, USA_PRO_MONTHLY_PRICE_LABEL } from "../lib/usClinicalHost";

/**
 * UpgradePrompt - Shown when Lite user hits limit or for key features.
 * Elegant, non-intrusive prompt to upgrade to Premium.
 */
export function UpgradePrompt({ message, feature, className = "" }) {
  const isUsHost = isUsClinicalHost();
  return (
    <div
      className={`rounded-xl border border-sky-200 bg-gradient-to-r from-sky-50/80 to-white p-4 ${className}`}
      data-testid="upgrade-prompt"
    >
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-sky-100 flex items-center justify-center">
            <Sparkles className="h-5 w-5 text-sky-600" />
          </div>
          <div>
            <p className="font-medium text-slate-800">{message}</p>
            <p className="text-sm text-slate-500">
              {isUsHost
                ? `Upgrade to Aurora Geriatric Professional for unlimited use · ${USA_PRO_MONTHLY_PRICE_LABEL}`
                : "Actualice a Aurora Geriátrica Profesional para uso ilimitado · $39/mes"}
            </p>
          </div>
        </div>
        <Link to="/configuracion/billing">
          <Button size="sm" className="bg-slate-800 hover:bg-slate-700">
            {isUsHost ? "View plans" : "Ver planes"}
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default UpgradePrompt;
